export const APP_SVG_ICONS = [
  { name: 'eye-closed', file: 'eye-closed.svg' },
  { name: 'eye-open', file: 'eye-open.svg' },
  { name: 'globe', file: 'globe.svg' },
  { name: 'chevron-up', file: 'chevron-up.svg' },
  { name: 'chevron-down', file: 'chevron-down.svg' },
  { name: 'user-icon', file: 'user-icon.svg' },
  { name: 'logout', file: 'logout.svg' },
  { name: 'help', file: 'help.svg' },
  { name: 'chevron-left', file: 'chevron-left.svg' },
  { name: 'chevron-right', file: 'chevron-right.svg' },
  { name: 'arrow-right', file: 'arrow-right.svg' },
  { name: 'sort', file: 'sort.svg' },
  { name: 'sort-up', file: 'sort-up.svg' },
  { name: 'sort-down', file: 'sort-down.svg' },
  { name: 'check', file: 'check.svg' },
  { name: 'publishing', file: 'publishing.svg' },
  { name: 'import', file: 'import.svg' },
  { name: 'linkedin', file: 'linkedin.svg' },
  { name: 'spinner', file: 'spinner.svg' },
  { name: 'plus', file: 'plus.svg' },
  { name: 'minus', file: 'minus.svg' },
  { name: 'attention', file: 'attention.svg' },
  { name: 'empty-drawer', file: 'empty-drawer.svg' },
  { name: 'refresh', file: 'refresh.svg' },
  { name: 'download', file: 'download.svg' },
  { name: 'download-hover', file: 'download-hover.svg' },
  { name: 'inbox', file: 'inbox.svg' },
  { name: 'mail', file: 'mail.svg' },
  { name: 'phone', file: 'phone.svg' },
  { name: 'delete', file: 'delete.svg' },
  { name: 'edit', file: 'edit.svg' },
  { name: 'search', file: 'search.svg' },
  { name: 'new-window', file: 'new-window.svg' },
  { name: 'success', file: 'success.svg' },
  { name: 'reorder', file: 'reorder.svg' },
  { name: 'star', file: 'star.svg' },
  { name: 'star-filled', file: 'star-filled.svg' },
  { name: 'close', file: 'close.svg' },
  { name: 'close-thin', file: 'close-thin.svg' },
  { name: 'trash', file: 'trash.svg' },
] as const satisfies readonly { readonly name: string; readonly file: string }[];
